const open = window.XMLHttpRequest.prototype.open;
function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      updateCart(this.response);
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

function updateCart(cartJson) {
    fetch(`${window.Theme.routes.cart_url}`)
    .then(response => response.text())
    .then(text => {
        const cartRaw = new DOMParser()
        .parseFromString(text, "text/html");
        // Update the cart button and min order value text
        const cartTitleRight = cartRaw.querySelector('.cart-title-right').innerHTML;
        document.querySelector('.cart-title-right').innerHTML = cartTitleRight;
        const cartCheckout = cartRaw.querySelector('.cart-checkout').innerHTML;
        document.querySelector('.cart-checkout').innerHTML = cartCheckout;
    })
    .catch(e => {
        console.error(e);
    })
}

